import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "evrideo-layout-icon",
  templateUrl: "./layout-icon.component.html",
  styleUrls: ["./layout-icon.component.scss"],
})
export class LayoutIconComponent implements OnInit {
  @Input()
  strokeColor = "#7B90A4";
  constructor() {}

  ngOnInit(): void {}
}
